import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() diameter = 100;
  @Input() strokeWidth = 7;

  constructor() { }

  ngOnInit(): void {
  }

}
